import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EnumService } from 'src/app/services/enum.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityService, SummaryItem } from 'src/app/services/activity.service';
import { Subscription } from 'rxjs';
import { ActivityPopupHandlerService } from 'src/app/services/activity-popup-handler.service';
interface ActivitySummaryItem {
  section: string;
  question: string;
  answer: string;
  popupData: any;
  formValues: any;
  completed: boolean;
}
@Component({
  selector: 'app-activity-popup',
  templateUrl: './activity-popup.component.html',
  styleUrls: ['./activity-popup.component.scss']
})
export class ActivityPopupComponent {
  @Input() activityPopupData: any;
  @Input() showActivitySummary: boolean = false;
  @Input() showSignoffError: boolean = false;
  @Output() closePopup = new EventEmitter<void>();
  @Output() deselectAnswer = new EventEmitter<void>();
  @Output() activitySummaryClick = new EventEmitter<void>();
  EnumService = EnumService;
  formGroup: FormGroup;
  activityTypeOptions = [
    { label: EnumService.ActivityType.DOCUMENT_SIGNOFF_ACTIVITY, value: 'Document Sign-Off' },
    { label: EnumService.ActivityType.FORM_SIGNOFF_ACTIVITY, value: 'Form Sign-Off' },
    { label: EnumService.ActivityType.CUSTOM_ACTIVITY, value: 'Custom Activity' }
  ];
  showAssigneeSelector = false;

  selectedAssignees: any[] = [];
  selectedOwner: any[] = [];

  expireDurationTypes: any[] = [];
  isPredefinedDate = false;

  showRequiredFieldsError = false;

  private readonly EMPTY_GUID_OWNER = '00000000-0000-0000-0000-000000000000';
  
  // TEMP ACTIVITY SUMMARY
  // activitySummaryList = [
  //   {
  //     title: 'DEV-234 triggered activity EO',
  //     section: 'The name of the section goes here and will truncate if too long...',
  //     question: 'The name of the question goes here and will also truncate...',
  //     answer: 'The answer text goes here and with one line truncation...',
  //     // assignee: 'John Smith',
  //     // dueDate: new Date('2023-12-15'),
  //     // completed: true
  //   },
  //   {
  //     title: 'DEV-235 triggered activity',
  //     section: 'Another section name that might be longer than the first one...',
  //     question: 'Another question text that could be quite long as well...',
  //     answer: 'Another answer that might need to be truncated if too long...',
  //     // assignee: '2 assignees',
  //     // dueDate: new Date('2023-12-20'),
  //     // completed: false
  //   },
  //   {
  //     title: 'DEV-236 triggered activity',
  //     section: 'Another section name that might be longer than the first one...',
  //     question: 'Another question text that could be quite long as well...',
  //     answer: 'Another answer that might need to be truncated if too long...',
  //     // assignee: '2 assignees',
  //     // dueDate: new Date('2023-12-20'),
  //     // completed: false
  //   }
  // ];

  activitySummaryList: SummaryItem[] = [];
  private subscription!: Subscription;

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
    private activityService: ActivityService,
    public activityHandlerService: ActivityPopupHandlerService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initializeDurationTypes();
    this.initializeForm();

    this.subscription = this.activityService.summaryItemsObservable$.subscribe(items => {
      console.log('items in here', items);
      this.activitySummaryList = items;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initializeForm() {
    let assigneeUsers = [];
    let displayAssignees = [];
    if (this.activityPopupData?.questionLogic?.isAssigneePredefined !== false && 
        this.activityPopupData?.questionLogic?.questionLogicAssignees?.selectedUsersAndGroups) {
      const usersAndGroups = this.activityPopupData.questionLogic.questionLogicAssignees.selectedUsersAndGroups;
    
      assigneeUsers = usersAndGroups
        .filter(item => item.userId !== null)
        .map(item => ({
          userId: item.userId,
          userName: item.name
        }));
      
      const groups = usersAndGroups
        .filter(item => item.groupId !== null)
        .map(item => ({
          userId: item.groupId,
          userName: item.name,
          isGroup: true,
          groupId: item.groupId
        }));
      
      const roles = (this.activityPopupData.questionLogic.questionLogicAssignees.selectedEntityRoles || [])
        .map(role => ({
          userId: role.entityRoleId,
          userName: role.entityRoleName,
          isRole: true,
          entityRoleId: role.entityRoleId
        }));

      displayAssignees = [...assigneeUsers, ...groups, ...roles];
    }

    this.selectedAssignees = displayAssignees;

    if (
      this.activityPopupData?.questionLogic?.isOwnerPredefined !== false
    ) {
      
      const activityOwnerID = this.activityPopupData?.questionLogic?.activityOwnerID;
      const activityEntityRoleOwnerID = this.activityPopupData?.questionLogic?.activityEntityRoleOwnerID;

      // NEW

      if (activityOwnerID && activityOwnerID !== this.EMPTY_GUID_OWNER && activityOwnerID !== null) {
      
        const ownerUser = this.activityPopupData?.userList?.find(
          (u: any) => u.userId === activityOwnerID
        );

        if (ownerUser) {
          console.log('ownerUser', ownerUser);
          this.selectedOwner = [ownerUser];
        } else {
          this.selectedOwner = [
            {
              userId: activityOwnerID,
              userName: '= ENTITY OWNER'
            }
          ];
        }
      } else if (activityEntityRoleOwnerID && activityEntityRoleOwnerID !== null && activityEntityRoleOwnerID !== 0) {
        const roleData = this.activityPopupData?.companyEntityRoles?.find(
          (role: any) => role.entityRoleId === activityEntityRoleOwnerID
        );
        const roleName = roleData?.entityRoleName || `Role ID: ${activityEntityRoleOwnerID}`;
        // For now, just display the number
        this.selectedOwner = [
          {
            userId: activityEntityRoleOwnerID,
            userName: roleName,
            isEntityRole: true,
            entityRoleId: activityEntityRoleOwnerID
          }
        ];
      } else {
        this.selectedOwner = [];
      }

      // OLD
      // const ownerUser = this.activityPopupData.userList.find(
      //   (u: any) => u.userId === this.activityPopupData.questionLogic.activityOwnerID
      // );

      // if (ownerUser) {
      //   console.log('ownerUser', ownerUser);
      //   this.selectedOwner = [ownerUser];
      //   // this.selectedOwner = [
      //   //   {
      //   //     userId: ownerUser.userId,
      //   //     userName: ownerUser.name
      //   //   }
      //   // ];
      // } else {
      //   this.selectedOwner = [
      //     {
      //       userId: this.activityPopupData.questionLogic.activityOwnerID,
      //       userName: '= ENTITY OWNER'
      //     }
      //   ];
      // }
    }

    const durationTypeId = this.getExpireDurationTypeId(this.activityPopupData?.questionLogic);

    this.formGroup = this.fb.group({
      activityType: [null],
      activityFormDisplay: [''],
      activityTitle: [
        (this.activityPopupData?.questionLogic?.isActTitlePredefined === true || this.activityPopupData?.questionLogic?.isActTitlePredefined === null) ? this.activityPopupData?.questionLogic?.activityTitle : '',
      ],
      activityDescription: [
        (this.activityPopupData?.questionLogic?.isDescriptionPredefined === true || this.activityPopupData?.questionLogic?.isDescriptionPredefined === null) ? this.activityPopupData?.questionLogic?.activityDescription : '',
      ],
      activityExplanation: [
        (this.activityPopupData?.questionLogic?.isExplanationPredefined === true || this.activityPopupData?.questionLogic?.isExplanationPredefined === null) ? this.activityPopupData?.questionLogic?.activityExplanation : '',
      ],
      assignees: [assigneeUsers.map(u => u.userId)],
      owner: [this.selectedOwner.map(u => u.userId)],
      dueDate: [''],
      isHighPriorityActivity: [(this.activityPopupData?.questionLogic?.isPriorityPredefined === true || this.activityPopupData?.questionLogic?.isPriorityPredefined === null) && this.activityPopupData?.questionLogic?.isHighPriorityActivity],
      // Add controls for duration field
      expireAfterDuration: [this.activityPopupData?.questionLogic?.activityRepeatDurationValue || ''],
      expireAfterDurationType: [durationTypeId || '']
    });

    if (this.activityPopupData?.questionLogic?.activityAssignedFormName) {
      this.formGroup.get('activityFormDisplay').setValue(
        this.activityPopupData.questionLogic.activityAssignedFormName
      );
    }

    if (this.activityPopupData?.questionLogic?.isPriorityPredefined === true  || this.activityPopupData?.questionLogic?.isPriorityPredefined === null) {
      this.formGroup.get('isHighPriorityActivity').disable();
    }
  }

  initializeDurationTypes() {
    this.translateService
      .get([
        "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_DAYS",
        "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_WEEKS",
        "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_MONTHS",
        "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_YEARS",
      ])
      .subscribe((res) => {
        this.expireDurationTypes = [
          {
            title: res["PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_DAYS"],
            id: 1,
            type: 'Days'
          },
          {
            title: res["PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_WEEKS"],
            id: 2,
            type: 'Week'
          },
          {
            title: res["PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_MONTHS"],
            id: 3,
            type: 'Month'
          },
          {
            title: res["PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.EXPIRATION_DURATION_YEARS"],
            id: 4,
            type: 'Year'
          }
        ];

        if (this.formGroup && this.activityPopupData?.questionLogic?.activityRepeatDurationType) {
          const durationTypeId = this.getExpireDurationTypeId(this.activityPopupData.questionLogic);
          if (durationTypeId) {
            this.formGroup.get('expireAfterDurationType').setValue(durationTypeId);
          }
        }
      });
  }

  onActivityTypeChange(event: any) {
    console.log('Selected activity type:', event.detail?.value);
  }

  onAssigneesSelected(users: any[]) {
    this.selectedAssignees = users;
    console.log('selectedAssignees', this.selectedAssignees);
    // this.formGroup.get('assignees').setValue(users.map(u => u.userId));
    const userIds = users.filter(u => !u.isRole && !u.isGroup).map(u => u.userId);
    this.formGroup.patchValue({ assignees: userIds });
  }

  onOwnerSelected(users: any[]) {
    this.selectedOwner = users;
    this.formGroup.get('owner').setValue(users.map(u => u.userId)); 
  }

  onDueDateChanged(event: any) {
    // Handle date change if needed
    // console.log('Due date changed:', this.formGroup.get('dueDate').value);
    console.log('Due date changed:', event);
    this.formGroup.get('dueDate').setValue(event);
    this.cdRef.detectChanges();
  }

  onClose() {
    this.closePopup.emit();
  }

  onSave(forceClose = false) {
    console.log('Save clicked');

    const completed = !this.isRequiredFieldsEmpty();

    if (this.showRequiredFieldsError && !forceClose) {
      console.log('Form has errors, Save is blocked');
      return;
    }

    if (completed || forceClose) {

      const formValues = this.formGroup.getRawValue();

      const summaryItem = {
        title: formValues.activityTitle,
        section: this.activityPopupData?.sectionName || '',
        question: this.activityPopupData?.questionText || '',
        answer: this.activityPopupData?.answerText || '',
        popupData: this.activityPopupData,
        formValues: {
          ...formValues,
          assigneesDisplay: this.selectedAssignees
        },
        completed,
        questionId: this.activityPopupData?.questionId,
        sectionId: this.activityPopupData?.sectionId,
      };

      console.log('summaryItem', summaryItem);

      // this.activitySummaryList.push(summaryItem);

      this.activityService.addOrUpdateSummary(summaryItem);

      // if (!completed) {
      //   this.showRequiredFieldsError = true;
      // } else {
      //   this.onClose();
      // }
      if (forceClose) {
        this.showRequiredFieldsError = true;
      } else {
        this.showRequiredFieldsError = false;
      }

      // this.onClose();
      if (this.activityHandlerService.openedFromSummary) {
        this.showActivitySummary = true;
        this.activityHandlerService.openedFromSummary = false;
        //this.cdRef.detectChanges();
      } else {
        this.onClose();
      }
    } else {
      this.showRequiredFieldsError = true;
    }

  }

  public isRequiredFieldsEmpty(): boolean {
    const titleEmpty = !this.formGroup.get('activityTitle').value;
    // const assigneesEmpty = !this.formGroup.get('assignees').value || this.formGroup.get('assignees').value.length === 0;
    const assigneesEmpty = !this.selectedAssignees || this.selectedAssignees.length === 0;
    const dueDateEmpty = !this.formGroup.get('dueDate').value;

    const durationValue = this.formGroup.get('expireAfterDuration')?.value;
    const durationType = this.formGroup.get('expireAfterDurationType')?.value;
    const durationEmpty = !durationValue || !durationType;

    // const ownerEmpty = !this.formGroup.get('owner')?.value;
    const ownerEmpty = !this.formGroup.get('owner')?.value || this.formGroup.get('owner').value.length === 0;

    if (this.activityPopupData?.questionLogic?.isDatePredefined === true || this.activityPopupData?.questionLogic?.isDatePredefined === null) {
      return titleEmpty || assigneesEmpty || durationEmpty || ownerEmpty;
    }
    
    return titleEmpty || assigneesEmpty || dueDateEmpty || ownerEmpty;
  }

  get requiredFieldsStatus(): string {
    return this.isRequiredFieldsEmpty()
      ? 'Required fields not defined'
      : 'Required fields are defined';
  }

  onBackFromError() {
    this.showRequiredFieldsError = false;
  }

  updateActivityDuration(event: any): void {
    // const durationValue = this.formGroup.get('expireAfterDuration')?.value;
    // console.log('Activity duration updated:', durationValue);
    const durationValue = Number(event.detail.value); // comes directly from input
    console.log('Activity duration updated:', durationValue);

    // make sure formControl stays in sync
    this.formGroup.get('expireAfterDuration')?.setValue(durationValue);
  }

  updateActivityDurationType(): void {
    const durationType = this.formGroup.get('expireAfterDurationType')?.value;
    console.log('Activity duration type updated:', durationType);
  }

  getExpireDurationType(data: any): number {
    if (!data) return 0;
    return data.activityRepeatDurationType || 0;
  }

  getExpireDurationTypeId(data: any): number {
    if (!data || !data.activityRepeatDurationType) return 0;
    
    const durationType = data.activityRepeatDurationType;
    console.log('Duration type from API:', durationType);
    
    // Map the string value to the corresponding ID
    const typeMap: {[key: string]: number} = {
      'Days': 1,
      'Week': 2,
      'Month': 3,
      'Year': 4
    };
    
    return typeMap[durationType] || 0;
  }

  openDetailView(summaryItem: any) {
    this.activityHandlerService.openedFromSummary = true;

    this.showRequiredFieldsError = false;

    this.activityPopupData = summaryItem.popupData;

    this.initializeForm();

    this.formGroup.patchValue(summaryItem.formValues);

    const ownerIds = summaryItem.formValues.owner || [];
    this.selectedOwner = ownerIds.map((id: string) => {
      // const match = this.activityPopupData?.userList?.find(
      //   (u: any) => u.userId === id
      // );
      // console.log('match', match);
      // return match
      //   ? { userId: match.userId, userName: match.userName }
      //   : { userId: id, userName: '= ENTITY OWNER' };
      if (typeof id === 'number') {
        // Check if we have the role name stored in formValues or popupData
        const roleData = this.activityPopupData?.companyEntityRoles?.find(
          (role: any) => role.entityRoleId === id
        );
        const roleName = roleData?.entityRoleName || `Role ID: ${id}`;
          
        return {
          userId: id,
          userName: roleName,
          isEntityRole: true,
          entityRoleId: id
        };
      }
      const match = this.activityPopupData?.userList?.find(
        (u: any) => u.userId === id
      );
      return match
        ? { userId: match.userId, userName: match.userName }
        : { userId: id, userName: '= ENTITY OWNER' };
    });

    // const assigneeIds = summaryItem.formValues.assignees || [];
    // this.selectedAssignees = this.activityPopupData?.userList
    //   ?.filter((u: any) => assigneeIds.includes(u.userId))
    //   .map((u: any) => ({ userId: u.userId, userName: u.userName }));

    if (summaryItem.formValues.assigneesDisplay) {
      this.selectedAssignees = summaryItem.formValues.assigneesDisplay;
    } else {
      const assigneeIds = summaryItem.formValues.assignees || [];
      this.selectedAssignees = this.activityPopupData?.userList
        ?.filter((u: any) => assigneeIds.includes(u.userId))
        .map((u: any) => ({ userId: u.userId, userName: u.userName })) || [];
    }

    console.log('ownerIds', ownerIds);
    console.log('selectedOwner', this.selectedOwner);

    this.showActivitySummary = false;
    this.cdRef.detectChanges();
  }

  onDeselect() {
    const questionLogicId = this.activityPopupData.questionLogic?.questionLogicId;
    if (questionLogicId != null) {
      this.activityService.removeSummaryItemForLogic(
        this.activityPopupData.sectionId,
        this.activityPopupData.questionId,
        questionLogicId
      );
    } else {
      this.activityService.removeSummaryItemByData(
        this.activityPopupData.sectionName,
        this.activityPopupData.questionText,
        this.activityPopupData.answerText,
        this.activityPopupData.sectionId,
        this.activityPopupData.questionId
      );
    }

    const deselectRefs = this.activityPopupData.deselectRefs || [this.activityPopupData.answerRef];
    deselectRefs.forEach((answerRef: any) => this.activityService.deselectAnswer(answerRef));

    this.onClose();
  }

  openActivitySummary() {
    this.showSignoffError = false;
    this.showActivitySummary = true;
  }

  getActivityDueDate(): string {
    const currentValue = this.formGroup.get('dueDate')?.value;
    if (!currentValue) return '';
    
    try {
      return new Date(currentValue).toISOString().split('T')[0].replace(/-/g, '/');
    } catch {
      return '';
    }
  }

  get filteredUserList() {
    return this.activityPopupData?.userList?.filter(
      user => user.userId !== "00000000-0000-0000-0000-000000000000"
    ) || [];
  }
}